import * as VideoType from '../constants/video-type';
import * as AnalyticsVideoType from '../constants/analytics-video-type';
import * as AnalyticsEventType from '../constants/analytics-event-type';

import ASDebugger from '../utils/ASDebugger';

import { inIframe } from '../utils/ASVPUtils';

import attempt from 'lodash/attempt';


class Analytics {
    constructor () {
        if (!window.trackMetrics) return false;
    }

    static setDebug (isDebug) {
        this.debug = ASDebugger(isDebug, this);
    }

    static getBaseVideoData (videoData) {
        if (!videoData) return {};

        return {
            id: videoData.id,
            title: this.getOmnitureVideoTitle(videoData),
            type: this.getOmnitureVideoType(videoData.type),
            offsite: inIframe(true),
            player_ad: undefined,
            segment_id: 1,
        };
    }

    static getOmnitureVideoType (type) {
        switch (type) {
            case VideoType.CLIP:
                return AnalyticsVideoType.CLIP;
            case VideoType.CLIPESODE:
                return AnalyticsVideoType.CLIPESODE;
            case VideoType.EPISODE:
                return AnalyticsVideoType.EPISODE;
            case VideoType.MARATHON:
                return AnalyticsVideoType.MARATHON;
            case VideoType.STREAM:
                return AnalyticsVideoType.STREAM;
            default:
                return AnalyticsVideoType.CLIP;
        }
    }

    static getOmnitureVideoTitle (videoData) {
        return (videoData.type === VideoType.STREAM) ? 'streams:' + videoData.title : videoData.collection_title + ':' + videoData.title;
    }

    static trackVideoStart (videoData, eventData) {
        var data = {
            video: this.getBaseVideoData(videoData)
        };
        data.video.duration = 0;
        data.video.autoplayed = eventData.autoplayed;
        this.trackMetrics(AnalyticsEventType.VIDEO_START, data);
        this.debug.log('trackVideoStart', data);
    }

    static trackVideoPause (videoData, eventData) {
        var data = {
            video: this.getBaseVideoData(videoData)
        };
        data.video.paused = eventData.paused;
        this.trackMetrics(AnalyticsEventType.VIDEO_PAUSE, data);
        this.debug.log('trackVideoPause', data);
    }

    static trackVideoProgress (videoData, eventData) {
        var data = {
            video: this.getBaseVideoData(videoData)
        };
        data.video.duration = eventData.duration;
        this.trackMetrics(AnalyticsEventType.VIDEO_PROGRESS, data);
        this.debug.log('trackVideoProgress', data);
    }

    static trackVideoFifty (videoData, eventData) {
        var data = {
            video: this.getBaseVideoData(videoData)
        };
        data.video.duration = eventData.duration;
        this.trackMetrics(AnalyticsEventType.VIDEO_FIFTY, data);
        this.debug.log('trackVideoFifty', data);
    }

    static trackVideoBuffering (videoData, eventData) {
        var data = {
            video: this.getBaseVideoData(videoData)
        };
        data.video.buffering = true;
        this.trackMetrics(AnalyticsEventType.VIDEO_BUFFER, data);
        this.debug.log('trackVideoBuffering', data);
    }

    static trackVideoComplete (videoData, eventData) {
        var data = {
            video: this.getBaseVideoData(videoData)
        };
        this.trackMetrics(AnalyticsEventType.VIDEO_COMPLETE, data);
        this.debug.log('trackVideoComplete', data);
    }

    static trackUserInteraction (videoData, eventData) {
        var data = {
            interaction: eventData.interaction,
            title: this.getOmnitureVideoTitle(videoData)
        };
        this.trackMetrics(AnalyticsEventType.USER_INTERACTION, data);
        this.debug.log('trackUserInteraction', data);
    }

    static trackPreroll (videoData, eventData) {
        var data = {
            video: this.getBaseVideoData(videoData)
        };
        this.trackMetrics(AnalyticsEventType.VIDEO_PREROLL, data);
        this.debug.log('trackPreroll', data);
    }

    static trackMidrollStart (videoData, eventData) {
        var data = {
            video: this.getBaseVideoData(videoData)
        };
        this.trackMetrics(AnalyticsEventType.VIDEO_MIDROLL_START, data);
        this.debug.log('trackMidrollStart', data);
    }

    static trackMidrollComplete (videoData, eventData) {
        var data = {
            video: this.getBaseVideoData(videoData)
        };
        this.trackMetrics(AnalyticsEventType.VIDEO_MIDROLL_COMPLETE, data);
        this.debug.log('trackMidrollComplete', data);
    }

    static trackPostrollStart (videoData, eventData) {
        var data = {
            video: this.getBaseVideoData(videoData)
        };
        this.trackMetrics(AnalyticsEventType.VIDEO_POSTROLL_START, data);
        this.debug.log('trackPostrollStart', data);
    }

    static trackPostrollComplete (videoData, eventData) {
        var data = {
            video: this.getBaseVideoData(videoData)
        };
        this.trackMetrics(AnalyticsEventType.VIDEO_POSTROLL_COMPLETE, data);
        this.debug.log('trackPostrollComplete', data);
    }

    static trackMetrics (type, data) {
        if (!data) return;
        return attempt(() => window.trackMetrics({ type, data }));
    }

    static getClassName () {
        return 'analytics';
    }
};



export default Analytics;


// WEBPACK FOOTER //
// ./src/player/analytics.js